

import IEdit from "./IEdit"
import ConstantDraw from "../constants/ConstantDraw"
/**
 * 编辑模块抽象类
 */
//1、整体拖拽
//2、关键点编辑
//3、标绘旋转
//4、基于标绘对象的
class EditBase extends IEdit {
    constructor(options) {
        super(options);
        this.options = options || {};
        this.isStarted = false;// 编辑标识
        this.entities = []; //脏数据
        this.pick = undefined;//关键点
        this.center = undefined;//中心点
        this.rotation = undefined;//旋转点
        this.positionMove = undefined; //平移点
        this.editGuid = this.guid(); //唯一标识
        this.callback = this.options.callback; //数据编辑回调
        this.drawBase = this.options.drawBase; //绘制者
        this.initCenter=true;
        this.initRotate=true;
    }

    //扩展属性
    static ext_id = "edit_Guid";  //标绘扩展ID和编辑类ID对应
    static ext_positions = "edit_positions"; //关键点坐标
    static ext_positionsCopy = "edit_copy"; //关键点坐标拷贝
    static ext_keyPos = "edit_keyPos"; //关键点实体
    static ext_keyFlag = "edit_keyFlag"; //关键点标识
    static ext_centerPos = "edit_center"; //中心点实体
    static ext_centerFlag = "edit_centerFlag"; //中心点标识
    static ext_rotation = "edit_rotation"; //旋转点实体
    static ext_rotationFlag = "edit_rotationFlag"; //旋转点标识

    //开启编辑
    start(plot) {
        if (this.isStarted) {
            return;
        }
        this.plot = plot; //当前标绘
        var $this = this;
        this.handler = new this.Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);

        this.handler.setInputAction((e) => $this.leftClick(e), $this.Cesium.ScreenSpaceEventType.LEFT_CLICK);
        this.handler.setInputAction((e) => $this.leftDown(e), $this.Cesium.ScreenSpaceEventType.LEFT_DOWN);
        this.handler.setInputAction((e) => $this.mouseMove(e), $this.Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        this.handler.setInputAction((e) => $this.leftUp(e), $this.Cesium.ScreenSpaceEventType.LEFT_UP);
        this.isStarted = true;

        this.initAttrPlot();
        this.initProperty();
    }

    //绑定动态属性
    initProperty() {

    }

    //数据发生改变触发
    updatePlot() {
        this.callback && this.callback(this.plot);
    }
    //初始化扩展属性
    initAttrPlot() {

        this.initExtID();
        this.initKeyPoint();
        this.initCenterPoint();
        this.initRotatePoint();
        //this.test()
    }

    test() {
        var a = this.plot.attrPlot[EditBase.ext_rotation].position.getValue();
        var c = this.plot.attrPlot['centerPos'];

        let positions = [];
        positions.push(a);
        for (var i = 0; i <= 360; i++) {
            var b = this.getRotateCenterPoint(c, positions[i], 1);
            this.createPoint(b, ConstantDraw.Style_KeyPos);
            positions.push(b);
        }
    }

    //初始化扩展ID
    initExtID() {
        this.plot.attrPlot = this.plot.attrPlot || {};
        this.plot.attrPlot[EditBase.ext_id] = this.editGuid;
    }
    //初始化关键点
    initKeyPoint() {
        var keyPos = this.plot.attrPlot[EditBase.ext_positions]; //拿到关键点数组
        var e_pos = [];
        for (let i = 0; i < keyPos.length; i++) {
            var pos = this.createPoint(keyPos[i], ConstantDraw.Style_KeyPos);
            this.entities.push(pos);
            pos.attrPlot = {
                e_index: i,
                [EditBase.ext_id]: this.editGuid,
                [EditBase.ext_keyFlag]: true
            };
            e_pos.push(pos);
        }
        this.plot.attrPlot[EditBase.ext_keyPos] = e_pos; //实体
    }

    //初始化中心点
    initCenterPoint() {
        if(!this.initCenter){
            return
        }
        var keyPos = this.plot.attrPlot[EditBase.ext_positions]; //拿到关键点数组
        if (keyPos.length >= 2) {
            var posArr = this.cart2Wgs84(keyPos);
            var center = this.getCenter(posArr);
            var cart = Cesium.Cartesian3.fromDegrees(center[0], center[1]);
            var ext_centerPos = this.createPoint(cart, ConstantDraw.Style_CenterPos);
            ext_centerPos.attrPlot = {
                [EditBase.ext_centerFlag]: true,
                [EditBase.ext_id]: this.editGuid
            };
            this.entities.push(ext_centerPos);
            this.plot.attrPlot[EditBase.ext_centerPos] = ext_centerPos; //实体
            this.plot.attrPlot['centerPos'] = cart;
        }
    }

    //初始化旋转点
    initRotatePoint() {

        if(!this.initRotate){
            return
        }

        var keyPos = this.plot.attrPlot[EditBase.ext_positions]; //拿到关键点数组
        if (keyPos.length <= 1) {
            return;
        }

        var rectangle = this.getRectangle(keyPos);
        var pos = this.createPoint(rectangle[1], ConstantDraw.Style_RotationPos); //topRight
        this.entities.push(pos);
        pos.attrPlot = {
            [EditBase.ext_id]: this.editGuid,
            [EditBase.ext_rotationFlag]: true
        };
        this.plot.attrPlot[EditBase.ext_rotation] = pos; //实体
    }
    //更新中心点
    updateCenter() {
        var keyPos = this.plot.attrPlot[EditBase.ext_positions]; //拿到关键点数组
        var pos = this.plot.attrPlot[EditBase.ext_centerPos];
        if (!pos || keyPos.length < 2) {
            return
        }
        var posArr = this.cart2Wgs84(keyPos);
        var center = this.getCenter(posArr);
        var cart = Cesium.Cartesian3.fromDegrees(center[0], center[1]);
        pos.position.setValue(cart); //更新坐标
        this.plot.attrPlot['centerPos'] = cart;

        this.updatePlot();
    }

    //更新旋转点
    updateRotate() {
        var keyPos = this.plot.attrPlot[EditBase.ext_positions]; //拿到关键点数组
        var pos = this.plot.attrPlot[EditBase.ext_rotation];
        if (!pos || keyPos.length <= 1) {
            return;
        }
        var rectangle = this.getRectangle(keyPos);
        var cart = rectangle[1]; //右上角为旋转点
        pos.position.setValue(cart); //更新坐标
    }

    //关键点整体平移
    translateAll(position) {
        if (!this.positionMove) {
            this.positionMove = position;
        }
        //记录差值 
        var diff = Cesium.Cartesian3.subtract(position, this.positionMove, new Cesium.Cartesian3());
        this.positionMove = position;
        var $this = this;
        //移动关键点
        var positions = this.plot.attrPlot[EditBase.ext_positions];
        for (let i = 0; i < positions.length; i++) {
            var newPos = Cesium.Cartesian3.add(positions[i], diff, new Cesium.Cartesian3());
            positions[i] = newPos;
            $this.plot.attrPlot[EditBase.ext_keyPos][i].position.setValue(newPos);
        }

        this.updatePlot();
    }
    //关键点整体旋转
    rotationAll(position) {
        var $this = this;
        var center = this.plot.attrPlot['centerPos'];
        var PA = this.plot.attrPlot['startPoint'];
        var angle = this.getAngleCenterPointDir(center, PA, position);
        if (isNaN(angle)) {
            return;
        }
        let theta = angle * (180 / Math.PI);
        var newPos = this.getRotateCenterPoint(center, PA, theta);
        this.rotation.position.setValue(newPos); //更新旋转点
        var positions = this.plot.attrPlot[EditBase.ext_positions];
        var positions_copy = this.plot.attrPlot[EditBase.ext_positionsCopy]
        for (let i = 0; i < positions_copy.length; i++) {
            var p = positions_copy[i];
            var newPos = this.getRotateCenterPoint(center, p, theta);
            positions[i] = newPos;
            $this.plot.attrPlot[EditBase.ext_keyPos][i].position.setValue(newPos);
        }

        this.updatePlot();
    }
    //备份点
    cloneKeyPos() {
        var positions = this.plot.attrPlot[EditBase.ext_positions];
        let arr = [];
        for (let i = 0; i < positions.length; i++) {
            arr.push(positions[i].clone());
        }
        this.plot.attrPlot[EditBase.ext_positionsCopy] = arr;
    }
    showEdit() {
        var editPos = this.plot.attrPlot[EditBase.ext_keyPos];
        for (let i = 0; i < editPos.length; i++) {
            editPos[i].show = true
        }
        var ext_centerPos = this.plot.attrPlot[EditBase.ext_centerPos];
        if (ext_centerPos) {
            ext_centerPos.show = true;
        }

        var ext_rotation = this.plot.attrPlot[EditBase.ext_rotation];
        if (ext_rotation) {
            ext_rotation.show = true;
        }
    }
    hideEdit() {
        var editPos = this.plot.attrPlot[EditBase.ext_keyPos];
        for (let i = 0; i < editPos.length; i++) {
            editPos[i].show = false
        }
        var ext_centerPos = this.plot.attrPlot[EditBase.ext_centerPos];
        if (ext_centerPos) {
            ext_centerPos.show = false;
        }

        var ext_rotation = this.plot.attrPlot[EditBase.ext_rotation];
        if (ext_rotation) {
            ext_rotation.show = false;
        }
    }
    //停止编辑
    stop() {
        if (this.handler) {
            this.handler.destroy();
            this.handler = null;
        }
        this.isStarted = false;// 编辑标识
        this.viewer.scene.screenSpaceCameraController.enableRotate = true;
    }
    clear() {
        for (var i = 0; i < this.entities.length; i++) {
            this.viewer.entities.remove(this.entities[i]);
        }

        this.pick = undefined;
        this.center = undefined;//
        this.rotation = undefined;//
        this.positionMove = undefined;
        this.centerPos = undefined;
    }

    getStyle(obj, style) {
        var res = {};
        for (const key in style) {
            res[key] = obj[key];
        }
        return res;
    }

    setStyle(obj, style) {
        for (const key in style) {
            obj[key] = style[key];
        }
    }

    leftClick(evt) {
        this.hideEdit();
        let pick = this.viewer.scene.pick(evt.position);
        var entity = this.getPickEnity(pick);
        if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
            this.showEdit();
        }
    }
    leftDown(evt) {
        this.pick = undefined;
        this.center = undefined;//中心点
        this.rotation = undefined;//旋转点
        let pick = this.viewer.scene.pick(evt.position);
        var entity = this.getPickEnity(pick);
        if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_keyFlag] && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
            this.pick = entity;
            this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
        }

        if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_centerFlag] && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
            this.center = entity;
            this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
        }
        if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_rotationFlag] && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
            this.rotation = entity;
            this.plot.attrPlot['startPoint'] = entity.position.getValue();
            this.cloneKeyPos();
            this.plot.rectangle && (this.rotation.startRotation = this.plot.rectangle.rotation);
            this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
        }
    }
    //移动事件
    mouseMove(evt) {
        var $this = this;
        //关键点
        if (this.pick) {
            var cartesian = this.getCatesian3FromPX(evt.endPosition);
            var i = this.pick.attrPlot.e_index;
            $this.plot.attrPlot[EditBase.ext_positions].splice(i, 1, cartesian);
            this.pick.position.setValue(cartesian);
            this.updateCenter();
            this.updateRotate();
        }

        //中心点
        if (this.center) {
            var cartesian = this.getCatesian3FromPX(evt.endPosition);
            this.center.position.setValue(cartesian);
            this.plot.attrPlot['centerPos'] = cartesian;
            this.translateAll(cartesian);
            this.updateRotate();
        }

        //旋转点
        if (this.rotation) {
            var cartesian = this.getCatesian3FromPX(evt.endPosition);
            this.rotationAll(cartesian);
        }
    }

    leftUp(evt) {
        this.pick = undefined;
        this.center = undefined;//中心点
        this.rotation = undefined;//
        this.positionMove = undefined;
        this.viewer.scene.screenSpaceCameraController.enableRotate = true;//解锁相机
    }
}

export default EditBase;